import { FC, useCallback, useMemo } from "react";

import {
  CommitmentsTabSwitcher,
  CommitmentsTabSwitcherProps,
} from "@/components/pages/commtiments/common/components/tag-switcher/CommitmentsTabSwitcher";
import { getDrawerDataGridPossibleGroupings } from "@/components/pages/commtiments/common/utils/constants/drawerDataGridPossibleGroupings";
import { commitmentsDetailsDrawerTargetTypeSelector } from "@/store/commitments/selectors/common/details-drawer/commitmentsDetailsDrawerTargetTypeSelector";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { commitmentsDetailsDrawerCoverageGroupingSelector } from "@/store/commitments/selectors/common/details-drawer/commitmentsDetailsDrawerCoverageGroupingSelector";
import { commitmentsTypeTabSelector } from "@/store/commitments/selectors/common/commitmentsTypeTabSelector";
import { commitmentsCurrentOrgProviderSelector } from "@/store/commitments/selectors/common/commitmentsCurrentOrgProviderSelector";
import { changeCommitmentDrawerDataGridGroupingThunk } from "@/store/commitments/thunks/common/changeCommitmentDrawerDataGridGroupingThunk";
import { SavingsPlanCoverageGrouping } from "@/services/cloudchipr.api";

export const CommitmentsDrawerDataGridGrouping: FC = () => {
  const dispatch = useAppDispatch();
  const type = useAppSelector(commitmentsDetailsDrawerTargetTypeSelector);
  const grouping = useAppSelector(
    commitmentsDetailsDrawerCoverageGroupingSelector,
  );
  const activeTab = useAppSelector(commitmentsTypeTabSelector);
  const provider = useAppSelector(commitmentsCurrentOrgProviderSelector);
  const tabChangeHandler = useCallback(
    (grouping: string) => {
      if (!grouping) {
        return;
      }
      dispatch(
        changeCommitmentDrawerDataGridGroupingThunk(
          grouping as SavingsPlanCoverageGrouping,
        ),
      );
    },
    [dispatch],
  );
  const tabs = useMemo(() => {
    if (!provider || !type) {
      return [];
    }
    return getDrawerDataGridPossibleGroupings(provider)?.[type]?.reduce(
      (result, item) => {
        result.push({
          value: item.value,
          label: activeTab === "savings_plan" ? item.spLabel : item.riLabel,
        });
        return result;
      },
      [] as CommitmentsTabSwitcherProps["tabs"],
    );
  }, [type, provider, activeTab]);

  if (!type) {
    return null;
  }

  return (
    <CommitmentsTabSwitcher
      tabs={tabs}
      onTabChange={tabChangeHandler}
      value={grouping}
      size="small"
    />
  );
};
